// @ts-nocheck

import { createAsyncThunk } from '@reduxjs/toolkit';

import { Post, Get } from "../../utils/apiUtils";


export const QueryExtraReducer = (builder) => {
    builder
        .addCase(startNewChat.pending, (state) => {
            state.isEnquiring = true;
        })
        .addCase(startNewChat.fulfilled, (state, action) => {
            state.isEnquiring = false;
            state.messages = [];
        })
        .addCase(startNewChat.rejected, (state) => {
            state.isEnquiring = false;
        })
        .addCase(enquireChat.pending, (state) => {
            state.isEnquiring = true;
            state.messages.push({ role: 'user', content: state.enquireText });
        })
        .addCase(enquireChat.fulfilled, (state, action) => {
            state.isEnquiring = false;
            state.messages.push(action.payload);
            state.enquireText = '';
        })
        .addCase(enquireChat.rejected, (state) => {
            state.isEnquiring = false;
        })
        .addCase(getChat.pending, (state) => {
            state.isEnquiring = true;
            state.loadingChat = true;
        })
        .addCase(getChat.fulfilled, (state, action) => {
            state.isEnquiring = false;
            state.loadingChat = false;
            state.messages = action.payload;
        })
        .addCase(getChat.rejected, (state) => {
            state.isEnquiring = false;
            state.loadingChat = false;
        })
        .addCase(pinMessage.fulfilled, (state, action) => {
            const { messageTs, pinState } = action.payload;
            const msgIndex = state.messages.findIndex(msg => msg.ts === messageTs);
            if (msgIndex !== -1) {
                state.messages[msgIndex].pinned = pinState;
            }
        })
        .addCase(getPinnedMessages.pending, (state) => {
            state.loadingPinned = true;
        })
        .addCase(getPinnedMessages.rejected, (state) => {
            state.loadingPinned = false;
        })
        .addCase(getPinnedMessages.fulfilled, (state, action) => {
            state.loadingPinned = false;
            state.pinnedMessages = action.payload;
        });
}

// Thunk to start a new chat
export const startNewChat = createAsyncThunk(
    'query/reset',
    async (action: any) => {
        try {
            const response = await Post('/chat/reset', {}, {msgKey: 'query'});
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to start new chat');
        }
    }
);

// Thunk to enquire (send a message in chat)
export const enquireChat = createAsyncThunk(
    'query/enquireChat',
    async (action:any) => {
        try {
            const response = await Post(`/chat/enquire`, 
                { message: action.message},
                {msgKey: 'query'}
            );
            return response.response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to send enquiry');
        }
    }
);

export const getChat = createAsyncThunk(
    'query/getChat',
    async (_, { rejectWithValue }) => {
        try {
            const response = await Get('/chat/', { msgKey: 'query' });
            return response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to get chat');
        }
    }
);

// Thunk to pin a message in chat
export const pinMessage = createAsyncThunk(
    'query/pinMessage',
    async (action: any) => {
        try {
            const response = await Post(`/chat/pin`, action, { msgKey: 'query' });
            return response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to pin message');
        }
    }
);

export const getPinnedMessages = createAsyncThunk(
    'query/getPinnedMessages',
    async (_, { rejectWithValue }) => {
        try {
            const response = await Get('/chat/pinned', { msgKey: 'query' });
            return response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to get pinned messages');
        }
    }
);